import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function FAQPage() {
  const navigate = useNavigate();

  const faqs = [
    {
      q: 'Comment fonctionne le suivi de chantier ?',
      a: 'Nous assurons un point hebdomadaire par email ou visio, avec compte-rendu d\'avancement, prévision semaine suivante et points d\'attention. Vous savez toujours où on en est.'
    },
    {
      q: 'Combien de temps pour recevoir un devis ?',
      a: 'Sous 48h ouvrées après réception de votre demande. Si une visite sur place est nécessaire, nous la planifions rapidement.'
    },
    {
      q: 'Intervenez-vous uniquement en Suisse romande ?',
      a: 'Oui, nous intervenons sur Genève, Lausanne, Montreux, Fribourg, Neuchâtel, Valais, Villars, Verbier et Crans-Montana.'
    },
    {
      q: 'Quels types de travaux pilotez-vous ?',
      a: 'Rénovations intérieures complètes ou partielles : cuisine, salle de bain, peinture, parquet, carrelage, plans 3D. Nous coordonnons tous les corps de métier nécessaires.'
    },
    {
      q: 'Puis-je suivre l\'avancement du chantier ?',
      a: 'Absolument. Vous recevez un compte-rendu hebdomadaire, et nous restons disponibles pour toute question en temps réel.'
    },
    {
      q: 'Que se passe-t-il si un imprévu survient ?',
      a: 'Nous anticipons au maximum. Si un imprévu survient, nous vous informons immédiatement, proposons des solutions et ajustons le planning en conséquence.'
    },
    {
      q: 'Les artisans sont-ils fiables ?',
      a: 'Nous travaillons uniquement avec des artisans qualifiés que nous connaissons. Nous vérifions leur travail à chaque étape.'
    },
    {
      q: 'Proposez-vous des plans 3D avant travaux ?',
      a: 'Oui, pour les gros projets, nous pouvons réaliser des projections photo-réalistes pour valider les choix esthétiques avant exécution. C\'est un service optionnel.'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      
      {/* Hero */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h1 
            className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold"
            style={{ color: 'var(--hr-text)' }}
          >
            Questions fréquentes
          </h1>
          <p 
            className="text-xl leading-relaxed"
            style={{ color: 'var(--hr-text-muted)' }}
          >
            Tout ce que vous devez savoir sur notre approche de la rénovation pilotée.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 sm:py-16">
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, i) => (
              <AccordionItem 
                key={i} 
                value={`item-${i}`}
                className="rounded-2xl border px-6" 
                style={{ borderColor: 'var(--hr-border)', backgroundColor: 'var(--hr-bg)' }}
              >
                <AccordionTrigger className="text-left hover:no-underline">
                  <span className="font-['Figtree'] font-semibold" style={{ color: 'var(--hr-text)' }}>
                    {faq.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent>
                  <p className="text-sm leading-relaxed pt-2" style={{ color: 'var(--hr-text-muted)' }}>
                    {faq.a}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 sm:py-20">
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="rounded-2xl border-[color:var(--hr-border)] text-center">
            <CardContent className="p-12 space-y-6">
              <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-semibold" style={{ color: 'var(--hr-text)' }}>
                Une autre question ?
              </h2>
              <p className="text-lg" style={{ color: 'var(--hr-text-muted)' }}>
                Demandez un devis, nous répondrons à toutes vos questions.
              </p>
              <Button
                size="lg"
                className="rounded-xl px-8"
                style={{ backgroundColor: 'var(--hr-primary)', color: 'var(--hr-primary-fg)' }}
                onClick={() => navigate('/devis')}
              >
                Demander un devis
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}